import {FC, ReactNode, Suspense} from 'react';

type ErrorProviderProps = {
  children: ReactNode;
};

const ErrorProvider: FC<ErrorProviderProps> = ({ children }) => <Suspense fallback={<div>Loading...</div>}>
    {children}
  </Suspense>

export default ErrorProvider;
